import { createContext } from 'react';

export type SignOutReason = 'user' | 'expired';

export interface Session {
  token: string | undefined;
  signIn: (token: string) => void;
  signOut: (reason?: SignOutReason) => void;
  /** Why the last sign-out happened; cleared by the next sign-in. */
  signOutReason: SignOutReason | undefined;
}

export const SessionContext = createContext<Session | undefined>(undefined);
